import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from 'nucleus-widgets/lib/BaseWidget';
import Button from 'nucleus-widgets/lib/Button/Button';
import ButtonStyles from 'nucleus-widgets/lib/Button/Button.less';
import { resolveTestId } from '@cvent/nucleus-test-automation';

const Classes = {
  ...ButtonStyles,
  button: {
    ...ButtonStyles
  }
};

function getOptionalValue(value, defaultValue) {
  return (value === null) || (typeof value === 'undefined') ? defaultValue : value;
}

/**
 * The event ContactPlanner widget.
 */
export default class ContactPlannerWidget extends BaseWidget {
  static displayName = 'ContactPlannerWidget';
  static propTypes = {
    config: PropTypes.shape({
      shared: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.object,
        displayEmail: PropTypes.bool,
        company: PropTypes.string,
        phoneNumber: PropTypes.string
      })
    }),
    classes: PropTypes.object,
    style: PropTypes.object,
    translate: PropTypes.func.isRequired
  };

  static getConfig(state, rawConfig, type, widgetId) {
    /*
     * Overriding BaseWidget.getConfig() was necessary
     *in order to pull most of the shared props from state.
     */
    const mappedConfig = super.getConfig(state, rawConfig, type, widgetId);
    const { firstName, lastName, company } = state.event.planner;
    mappedConfig.shared = {
      ...mappedConfig.shared,
      firstName: getOptionalValue(mappedConfig.shared.firstName, firstName),
      lastName: getOptionalValue(mappedConfig.shared.lastName, lastName),
      company: getOptionalValue(mappedConfig.shared.company, company)
    };
    return mappedConfig;
  }

  static defaultProps = {
    classes: Classes
  };

  constructor(props) {
    super(props);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  getStyleObject() {
    return {
      ...super.getStyleObject(),
      button: {
        button: this.getElementInlineStyle('button')
      },
      buttonWrapper: { textAlign: this.getElementText('button').textAlign },
      text: this.getElementInlineStyle('text'),
      contactUsModalStyles: {
        modalPlannerNameStyles: this.getElementInlineStyle('contactUsModalStyles.modalPlannerNameStyles'),
        modalFieldStyles: this.getElementInlineStyle('contactUsModalStyles.modalFieldStyles'),
        modalLabelStyles: this.getElementInlineStyle('contactUsModalStyles.modalLabelStyles'),
        modalSendButtonStyles: this.getElementInlineStyle('contactUsModalStyles.modalSendButtonStyles')
      }
    };
  }

  onButtonClick() {
    if (this.props.onClick) {
      const { shared, appData, buttonText } = this.props.config;
      const { isPreview, translate } = this.props;
      this.props.onClick(buttonText, {
        firstName: translate(shared.firstName),
        lastName: translate(shared.lastName),
        phoneNumber: translate(shared.phoneNumber),
        company: translate(shared.company),
        displayEmail: appData.displayEmail,
        emailAddress: appData.email && appData.email.emailAddress
      },
      this.getStyleObject(),
      isPreview);
    }
  }

  render() {
    const { config, classes, translate } = this.props;

    /*
     * Originally, buttons were implemented with rich text editors, but since then
     * they have been updated to be normal textboxes. So we have to allow the text
     * property to come in as rich text or normal plain text. https://jira/browse/FLEX-6581
     */
    let isRichText = false;
    let text = config.buttonText;
    if (config.buttonText.hasOwnProperty('htmlContent')) {
      isRichText = true;
      text = config.buttonText.htmlContent;
    }
    return (
      <Button
        {...resolveTestId(this.props)}
        classes={classes}
        style={this.getStyleObject()}
        text={translate(text)}
        onClick={this.onButtonClick}
        isRichText={isRichText}
      />
    );
  }
}
